import { Label, Icon, PersonaSize, PersonaPresence, IconButton } from '@fluentui/react';
import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { _renderRow } from '../../control/function/detailList';
import * as Api from '../../api/src';
import '../../css/components/test.scss';
import useToken from '../account/login/useToken';
import { commonfn } from '../../common/commonfn';
import { Loading } from '../../control/loading';
import moment from 'moment';
import { Doughnut } from 'react-chartjs-2';
import { Avatar } from '../../control/avatar';
import ModaProductSpecification from '../settings/products/modal/modalProductSpecification';

const chartOptions = {
  plugins: { legend: { display: false }, tooltip: { enabled: false } },
  responsive: true,
  maintainAspectRatio: true,
};

interface GeneralMatrixProps {
  MatrixItem: Api.MatrixItemGeneral;
  IsLocked: boolean;
  RefeshTab: () => void;
}
const GeneralMatrix = ({ MatrixItem, IsLocked, RefeshTab }: GeneralMatrixProps) => {
  const {} = useToken();
  const { t } = useTranslation();
  const [isShowLoading, SetIsShowLoading] = React.useState(true);

  const dataChart = {
    labels: ['Complete', 'Remaining'],
    datasets: [
      {
        data: [
          MatrixItem.TotalModuleApproved,
          parseInt(MatrixItem.TotalModule as any) - parseInt(MatrixItem.TotalModuleApproved as any),
        ],
        backgroundColor: ['#0aa252', '#D9D9D9'],
      },
    ],
  };
  React.useEffect(() => {
    getDetailGeneral();
  }, [MatrixItem]);

  const getPerson = (name: string, date: string) => {
    if (name) {
      return name + ' ' + t('On') + ' ' + moment(date).format('DD/MM/yyyy hh:mm');
    }
    return '-';
  };

  const [isOpenModal, SetIsOpenModal] = React.useState(false);

  const getDetailGeneral = () => {
    setTimeout(() => {
      SetIsShowLoading(false);
    }, 500);
  };

  return (
    <div className="matrix-detail margin-left-0 margin-right-0 page-content">
      <Loading isShow={isShowLoading}></Loading>
      <div className="ms-Grid" dir="ltr" style={{ width: 1024 }}>
        <div className="ms-Grid-row">
          <div className="label ms-Grid-col ms-lg3">
            <Label>{t('ID')}</Label>
          </div>
          <div className="ms-Grid-col ">{MatrixItem.Id}</div>
        </div>
        <div className="ms-Grid-row ">
          <div className="label ms-Grid-col ms-lg3">
            <Label>{t('Status')}</Label>
          </div>
          <div className="ms-Grid-col display-flex">
            <div className="chartBox">
              <Doughnut data={dataChart} options={chartOptions} />
            </div>
            &nbsp;
            <div className="display-flex">
              {MatrixItem.TotalModuleApproved}/{MatrixItem.TotalModule}
            </div>
          </div>
        </div>
        <div className="ms-Grid-row ">
          <div className="label  ms-Grid-col ms-lg3">
            <Label>{t('CreatedBy')}</Label>
          </div>
          <div className="ms-Grid-col">
            {getPerson(MatrixItem.CreateByUser?.FullName || '', MatrixItem.CreatedOn || '')}
          </div>
        </div>
        <div className="ms-Grid-row ">
          <div className="label ms-Grid-col ms-lg3">
            <Label>{t('LastUpdated')}</Label>
          </div>
          <div className="ms-Grid-col">
            {getPerson(MatrixItem.LastModifiedByUser?.FullName || '', MatrixItem.LastModifiedOn || '')}
          </div>
        </div>
        <div className="ms-Grid-row ">
          <div className="label ms-Grid-col ms-lg3">
            <Label>{t('ManagedBy')}</Label>
          </div>
          <div className="ms-Grid-col">
            <div className="display-flex">
              {MatrixItem.ManagedBy?.map((item, idx) => {
                return (
                  <React.Fragment key={idx}>
                    <Avatar
                      keyColor={item.FullName || ''}
                      imageInitials={commonfn.getNameInitial(item.FullName || '')}
                      text={item.FullName || ''}
                      size={PersonaSize.size32}
                      presence={PersonaPresence.none}
                      className={''}
                      IsShowTooltip={true}
                      hidePersonaDetails={false}
                      RandomColor={true}
                    />
                    &nbsp;
                  </React.Fragment>
                );
              })}
            </div>
          </div>
        </div>
        <div className="ms-Grid-row ">
          <div className="label ms-Grid-col ms-lg3">
            <Label>{t('ProductModel')}</Label>
          </div>
          <div className="ms-Grid-col">{MatrixItem.Product?.Name}</div>
        </div>
        <div className="ms-Grid-row ">
          <div className="label ms-Grid-col ms-lg3">
            <Label>{t('GTIN')}</Label>
          </div>
          <div className="ms-Grid-col">{MatrixItem.Product?.GTIN || '-'}</div>
        </div>
        <div className="ms-Grid-row ">
          <div className="label ms-Grid-col ms-lg3">
            <Label>{t('ArticleNumber')}</Label>
          </div>
          <div className="ms-Grid-col">{MatrixItem.Product?.ArticleNumber || '-'}</div>
        </div>
        <div className="ms-Grid-row ">
          <div className="label ms-Grid-col ms-lg3">
            <Label>{t('Category')}</Label>
          </div>
          <div className="ms-Grid-col">{MatrixItem.Product?.Category?.Name}</div>
        </div>
        <div className="ms-Grid-row ">
          <div className="label ms-Grid-col ms-lg3">
            <Label>{t('Year')}</Label>
          </div>
          <div className="ms-Grid-col">{MatrixItem.Product?.Year}</div>
        </div>
        <div className="ms-Grid-row ">
          <div className="label ms-Grid-col ms-lg3">
            <Label>{t('Vendor')}</Label>
          </div>
          <div className="ms-Grid-col">{MatrixItem.Product?.Vendor?.Name}</div>
        </div>
      </div>
      <hr></hr>

      <div className="ms-Grid" dir="ltr" style={{ width: 1024 }}>
        <div className="ms-Grid-row flex-center">
          <div className="ms-Grid-col ms-lg3">
          <h2>{t(`Product's specification`)}</h2>
          </div>
          <div className="ms-Grid-col ms-lg9" style={{textAlign: 'right'}}>
          <IconButton style={{alignItems: 'right'}} iconProps={{ iconName: 'Edit' }} aria-label="edit" onClick={()=>SetIsOpenModal(true)} />
          </div>
        </div>
      </div>
      
      <div className="ms-Grid" dir="ltr" style={{ width: 1024 }}>
        <div className="ms-Grid-row flex-center">
          <div className="ms-Grid-col ms-lg3">
            <Label>{t('Component')}</Label>
          </div>
          <div className="ms-Grid-col ms-lg3">
            <Label>{t('ComponentBrand')}</Label>
          </div>
          <div className="ms-Grid-col ms-lg3">
            <Label>{t('ComponentModel')}</Label>
          </div>
        </div>
        {MatrixItem.Specifications?.map((item) => {
          return (
            <div key={item.ComponentName} className="ms-Grid-row flex-center">
              <div className="ms-Grid-col ms-lg3">{item.ComponentName}</div>
              <div className="ms-Grid-col ms-lg3">{item.CBrandName || '-'}</div>
              <div className="ms-Grid-col ms-lg3">{item.CModelName || '-'}</div>
            </div>
          );
        })}
      </div>


      <hr></hr>
      <h2>{t('Modules')}</h2>
      <div className="ms-Grid" dir="ltr" style={{ width: 1024 }}>
        <div className="ms-Grid-row flex-center">
          <div className="ms-Grid-col ms-lg3">
            <Label>{t('Name')}</Label>
          </div>
          <div className="ms-Grid-col ms-lg3">
            <Label>{t('Type')}</Label>
          </div>
          <div className="ms-Grid-col ms-lg3">
            <Label>{t('Status')}</Label>
          </div>
          <div className="ms-Grid-col ms-lg3">
            <Label>{t('Deadline')}</Label>
          </div>
        </div>
        {MatrixItem.ModuleDetails?.map((item) => {
          return (
            <div key={item.Id} className="ms-Grid-row flex-center">
              <div className="ms-Grid-col ms-lg3">{item.ModuleName}</div>
              <div className="ms-Grid-col ms-lg3">{item.Type || '-'}</div>
              <div className="ms-Grid-col ms-lg3 display-flex">
                {item.Status === 'Approved' ? (
                  <Icon className={'Approved'} iconName="SkypeCircleCheck"></Icon>
                ) : item.Status === 'OverDue' ? (
                  <Icon className={'OverDue'} iconName="Warning"></Icon>
                ) : item.Status === 'OnGoing' ? (
                  <Icon className={'OnGoing'} iconName="Clock"></Icon>
                ) : (
                  <Icon className={'Pending'} iconName="CircleHalfFull"></Icon>
                )}
                &nbsp;{t(item.Status || '')}
              </div>
              <div className="ms-Grid-col ms-lg3">
                {item.Deadline ? moment(item.Deadline).format('DD/MM/yyyy') : '-'}
              </div>
            </div>
          );
        })}
      </div>

      {isOpenModal && (
        <ModaProductSpecification
          IsOpen={isOpenModal}
          ProductId={MatrixItem.Product?.Id ?? 0}
          Item={MatrixItem.Specifications ?? []}
          onCloseModal={() => {
            SetIsOpenModal(false);
          }}
          onSaveClick={() => {
            RefeshTab();
          }}
        ></ModaProductSpecification>
      )}

    </div>
  );
};
export default GeneralMatrix;